import Highcharts from 'highcharts'
import sunburst from 'highcharts/modules/sunburst.js'
import HighchartsReact from 'highcharts-react-official'
import { useRef } from 'react'

import { BasePoint, ChartOptionsProps, getChartOptions } from './chart-options'
import classes from './index.module.scss'

export * from './loading'

sunburst(Highcharts)

type Props = ChartOptionsProps<BasePoint>

export const SunburstChart = (props: Props) => {
  const ref = useRef()
  const chartOptions = getChartOptions(props)

  return (
    <HighchartsReact
      ref={ref}
      containerProps={{ className: classes.root }}
      highcharts={Highcharts}
      options={chartOptions}
    />
  )
}
